import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function SobrePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="relative h-[60vh] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/e9d7aeabf7f78384060ee4c807f9839d.jpg"
              alt="Sobre a Bravia Group"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-black/40"></div>
          </div>
          <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-12 flex items-center">
            <div className="max-w-3xl">
              <h1 className="text-6xl font-bold text-white mb-6">Nossa história e propósito</h1>
              <p className="text-2xl text-white/90 font-light">
                Construindo mais do que casas. Construindo confiança, oportunidades e lares com propósito.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-white py-24">
          <div className="max-w-5xl mx-auto px-6 lg:px-12">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-4xl font-bold text-black mb-8">A história da Bravia Group</h2>
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                A Bravia Group existe por um motivo simples: tornar o investimento em construção residencial na Flórida mais claro, mais organizado e muito mais confiável.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                A empresa foi fundada por Leandro Varges, empreendedor e investidor, com atuação no mercado financeiro americano, e hoje direciona essa experiência para o real estate com um padrão que muita gente procura: processo bem definido, acompanhamento de perto e comunicação transparente do início ao fim.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed mb-12">
                Nosso foco é construir lares com propósito e previsibilidade, entregando um caminho seguro para quem quer investir na Flórida com confiança, sem promessas vazias e sem surpresas no meio do caminho.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-16">
                <div className="text-center">
                  <div className="text-5xl font-bold text-gold-500 mb-2">50+</div>
                  <p className="text-gray-600 font-medium">Casas entregues</p>
                </div>
                <div className="text-center">
                  <div className="text-5xl font-bold text-gold-500 mb-2">100%</div>
                  <p className="text-gray-600 font-medium">Prazos cumpridos</p>
                </div>
                <div className="text-center">
                  <div className="text-5xl font-bold text-gold-500 mb-2">200+</div>
                  <p className="text-gray-600 font-medium">Investidores satisfeitos</p>
                </div>
              </div>

              <h2 className="text-4xl font-bold text-black mb-8 mt-16">Missão, Visão e Valores</h2>
              
              <div className="bg-beige-50 rounded-2xl p-10 mb-8">
                <h3 className="text-2xl font-bold text-black mb-4">Missão</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Oferecer oportunidades de investimento em construção residencial na Flórida com transparência total, acompanhamento constante e compromisso com a entrega de qualidade.
                </p>
              </div>

              <div className="bg-beige-50 rounded-2xl p-10 mb-8">
                <h3 className="text-2xl font-bold text-black mb-4">Visão</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Ser referência em construção residencial na Flórida, reconhecida pela previsibilidade, qualidade e relacionamento de longo prazo com investidores.
                </p>
              </div>

              <div className="bg-beige-50 rounded-2xl p-10">
                <h3 className="text-2xl font-bold text-black mb-6">Valores</h3>
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                    <div>
                      <strong className="text-black">Transparência:</strong>
                      <span className="text-gray-700"> Comunicação clara e honesta em todas as etapas</span>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                    <div>
                      <strong className="text-black">Qualidade:</strong>
                      <span className="text-gray-700"> Compromisso com acabamento premium e atenção aos detalhes</span>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                    <div>
                      <strong className="text-black">Previsibilidade:</strong>
                      <span className="text-gray-700"> Prazos realistas e cumprimento rigoroso do cronograma</span>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                    <div>
                      <strong className="text-black">Relacionamento:</strong>
                      <span className="text-gray-700"> Construção de parcerias duradouras com investidores</span>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                    <div>
                      <strong className="text-black">Inovação:</strong>
                      <span className="text-gray-700"> Busca constante por melhorias e novas soluções</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-beige-50 py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <h2 className="text-4xl font-bold text-black text-center mb-16">Nossa forma de trabalhar</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div className="bg-white rounded-2xl p-10">
                <div className="w-16 h-16 bg-gold-500/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-eye-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">Transparência Total</h3>
                <p className="text-gray-700 leading-relaxed">
                  Todos os investidores têm acesso completo a documentos, relatórios financeiros, cronogramas e atualizações de obra. Nada fica escondido. Você sabe exatamente onde seu investimento está e como está sendo aplicado.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-10">
                <div className="w-16 h-16 bg-gold-500/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-star-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">Padrão de Qualidade</h3>
                <p className="text-gray-700 leading-relaxed">
                  Trabalhamos apenas com fornecedores certificados e materiais de primeira linha. Cada projeto passa por rigoroso controle de qualidade em todas as etapas, garantindo acabamento premium e durabilidade.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-10">
                <div className="w-16 h-16 bg-gold-500/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-calendar-check-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">Cumprimento de Prazos</h3>
                <p className="text-gray-700 leading-relaxed">
                  Nossos cronogramas são realistas e baseados em experiência comprovada. Trabalhamos com margens de segurança e gestão profissional para garantir que cada projeto seja entregue no prazo acordado.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-10">
                <div className="w-16 h-16 bg-gold-500/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-team-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">Time Experiente</h3>
                <p className="text-gray-700 leading-relaxed">
                  Nossa equipe é formada por profissionais com décadas de experiência em construção, gestão de projetos e mercado imobiliário. Todos baseados na Flórida, conhecendo profundamente o mercado local.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Construction%20site%20behind%20the%20scenes%20in%20Florida%20showing%20quality%20control%20inspection%2C%20professional%20team%20reviewing%20building%20details%2C%20modern%20residential%20construction%20with%20attention%20to%20craftsmanship%2C%20natural%20lighting%20highlighting%20work%20in%20progress%2C%20documentary%20style%20photography&width=800&height=600&seq=sobre-bastidores-1&orientation=landscape"
                  alt="Bastidores Bravia Group"
                  className="w-full h-[500px] object-cover object-center rounded-2xl shadow-xl"
                />
              </div>
              <div>
                <h2 className="text-4xl font-bold text-black mb-6">Bastidores da construção</h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  Cada projeto da Bravia Group passa por um processo rigoroso de planejamento, execução e controle de qualidade. Nosso time acompanha diariamente o progresso das obras, garantindo que cada detalhe esteja de acordo com o padrão estabelecido.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                  Investidores recebem relatórios semanais com fotos, vídeos e atualizações detalhadas. Além disso, podem agendar visitas presenciais ao canteiro de obras a qualquer momento.
                </p>
                <a
                  href="https://wa.me/5511999999999"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-black text-white rounded-full font-semibold hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
                >
                  Falar com a Bravia
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
